import React from "react"
import {
  Card,
  Col,
  Container,
  Row,
  CardBody,
  Label,
  Button,
  Form,
  Input,
  FormFeedback,
  ButtonGroup,
} from "reactstrap"
import * as Yup from "yup"
import { useFormik } from "formik"
import { useSelector, useDispatch } from "react-redux"
import { useParams } from "react-router-dom"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { ToastContainer, toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

import {
  editPackingStandard,
  updatePackingStandard,
} from "../../../store/actions"

import { useEffect, useState } from "react"

const EditPackingStandard = props => {
  const dispatch = useDispatch()
  document.title = "Edit packing standard"
  const { id } = useParams()

  const [details, setDetails] = useState({})

  useEffect(() => {
    dispatch(editPackingStandard(id))
  }, [dispatch])

  const packingStands = useSelector(state => state.packingStandard)

  useEffect(() => {
    let packing = []
    if (
      packingStands &&
      packingStands.packingStandard &&
      packingStands.packingStandard.length > 0
    ) {
      packing = packingStands.packingStandard.filter(
        packingStandard => packingStandard.packing_standard_id == id
      )
    }
    if (packing.length > 0) {
      setDetails(packing[0])
    } else {
      props.history.push("/dropdown/packing_standard/list")
    }
  }, [])

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      packing_standard_id:
        details && details.packing_standard_id
          ? details.packing_standard_id
          : "",

      packing_standard:
        details && details.packing_standard ? details.packing_standard : "",

      is_default: details && details.is_default ? 1 : 0,
    },
    validationSchema: Yup.object({
      packing_standard: Yup.string().required("Please enter packing standard"),
    }),
    onSubmit: values => {
      values.packing_standard_id = id // packing_standard_id is from api thats why this needs to be same with "id"
      dispatch(updatePackingStandard(values, props.history))
    },
  })

  const { error } = useSelector(state => ({
    error: state.packingStandard.error,
  }))

  useEffect(() => {
    if (error) {
      toast.dismiss()
      toast.error(error, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: false,
        progress: undefined,
      })
    }
  }, [error])

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs breadcrumbItem="Edit Packing Standard" />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  {error ? <ToastContainer /> : ""}
                  <Form
                    id="editpckstndsForm"
                    onSubmit={e => {
                      e.preventDefault()
                      validation.handleSubmit()
                      return false
                    }}
                  >
                    <Row>
                      <Col md={6}>
                        <div className="mb-3 mt-1">
                          <Label htmlFor="pckst">Packing Standard</Label>
                          <Input
                            name="packing_standard"
                            type="text"
                            id="pckst"
                            autoComplete="off"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.packing_standard || ""}
                          />
                          {validation.touched.packing_standard &&
                          validation.errors.packing_standard ? (
                            <FormFeedback type="invalid">
                              {validation.errors.packing_standard}
                            </FormFeedback>
                          ) : null}
                        </div>
                      </Col>
                    </Row>
                    <div>
                      <h6>Default : </h6>
                      <ButtonGroup>
                        <Button
                          name="is_default"
                          color="success"
                          outline
                          value={1}
                          active={validation.values.is_default == 1}
                          onClick={validation.handleChange}
                        >
                          Yes
                        </Button>

                        <Button
                          name="is_default"
                          color="secondary"
                          outline
                          value={0}
                          active={validation.values.is_default == 0}
                          onClick={validation.handleChange}
                        >
                          No
                        </Button>
                      </ButtonGroup>
                    </div>
                    <br />
                    <div>
                      {packingStands && packingStands.loading ? (
                        <button
                          type="submit"
                          className="btn btn-primary w-md"
                          disabled
                        >
                          Updating ...
                        </button>
                      ) : (
                        <button type="submit" className="btn btn-primary w-md">
                          Update
                        </button>
                      )}
                    </div>
                  </Form>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
        {/* container-fluid */}
      </div>
    </React.Fragment>
  )
}

export default EditPackingStandard
